var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4443 10.9838L12.0553 9.50775C12.4958 9.10338 12.8054 8.5766 12.9444 7.99502C13.0834 7.41344 13.0454 6.80359 12.8353 6.24375L12.1483 4.40925C11.8916 3.72438 11.3835 3.16313 10.7275 2.83984C10.0714 2.51655 9.31677 2.45554 8.6173 2.66925C6.0433 3.45675 4.0648 5.84925 4.6738 8.69025C5.0743 10.5593 5.8408 12.9053 7.2928 15.4013C8.7478 17.9033 10.4098 19.7513 11.8348 21.0503C13.9858 23.0078 17.0608 22.5188 19.0393 20.6738C19.5697 20.1793 19.8915 19.5011 19.9391 18.7776C19.9868 18.054 19.7567 17.3395 19.2958 16.7798L18.0358 15.2498C17.6558 14.7871 17.146 14.4487 16.5721 14.2782C15.9982 14.1076 15.3863 14.1127 14.8153 14.2928L12.7333 14.9483C12.1956 14.3934 11.7245 13.7777 11.3293 13.1138C10.9479 12.4423 10.6507 11.7264 10.4443 10.9823V10.9838Z",
    fill: "#4CAF50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.e62de61f380759f1d0cf6f88f6d66fde.svg";
export { ForwardRef as ReactComponent };